import React, { ChangeEventHandler, FocusEventHandler, FormEvent, useCallback, useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";

import { SKText } from "../models/SKText";

interface AddTextAreaFieldProps {
  name: string;
  index?: number;
  title?: string;
  note?: string;
  placeholder: string;
  height: number;
  charAllowed: number;
  value: string;
  isTitleSpace?: boolean;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  notesclass?: string;
  disabled?: boolean;
  onBlur?: FocusEventHandler<HTMLTextAreaElement> | undefined;
  onFocus?: FocusEventHandler<HTMLTextAreaElement> | undefined;
  error?: string;
  //onValidation: (name: string, isValid: boolean) => void;
}

export const AddTextAreaField = ({
  name,
  title,
  note,
  placeholder,
  height,
  charAllowed,
  //onValidation,
  index,
  isTitleSpace = false,
  value,
  notesclass = "notes-class-content !mb-[0px]",
  onChange,
  disabled = false,
  onBlur,
  onFocus,
  error,
}: AddTextAreaFieldProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  // import { useNavigationBar } from "../../../context/NavigationContext";
  const [inputValue, setInputValue] = useState(String);
  const [localValue, setLocalValue] = useState(value);
  //const [error, setError] = useState<string>("");
  const schema = Yup.object().shape({
    message: Yup.string().required(`Text is required!`).max(charAllowed),
  });

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, []);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea && localValue?.length === 0) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  }, [textareaRef, localValue]);

  /*   useEffect(() => {
      const validateForm = async () => {
        try {
          await schema.validate({ message: contentData.text });
          setError("");
          onValidation(name, true);
        } catch (err) {
          let error = err as Yup.ValidationError;
          setError(error.message);
          onValidation(name, false);
        }
      };
      validateForm();
    }, [contentData]); */

  const handleInput = useCallback(
    (e: FormEvent) => {
      const textarea = textareaRef.current;
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    },
    [textareaRef]
  );

  return (
    <div className="relative w-full min-w-[200px]">
      <div className="flex flex-col mb-[15px]">
        <div id="titledata" className={`flex items-center ${isTitleSpace ? "pb-[10px]" : ""}`}>
          <span>{index && <span className="content_count">{index}</span>}</span>
          {name && <span className={`content_title ${!isTitleSpace ? "pb-[10px]" : ""}`}>{title}</span>}
        </div>
        {note && <div className={notesclass}>{note}</div>}
      </div>
      <div className="flex rectangle-class">
        <textarea
          name={name}
          className={`rectangle-text w-full md:max-w-[480px]  ${disabled ? "text-skgray" : "text-black"}`}
          style={{ minHeight: `${height}px` }}
          placeholder={placeholder}
          ref={textareaRef}
          // onInput={handleInput}

          value={localValue}
          onChange={e => {
            setLocalValue(e.target.value);
            onChange(e);
          }}
          maxLength={charAllowed}
          rows={5}
          // cols={30}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
        ></textarea>
      </div>
      {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
      {!error && <div className="remaining-characters">{charAllowed - (localValue?.length ?? 0)} characters remaining.</div>}
    </div>
  );
};
